import PageHeader from "ui/components/Page/PageHeader";
import { Flex } from "@chakra-ui/layout";
import Field from "ui/components/Input/Field";
import { CriarPostagemForm } from "core/features/mural/typings";
import { useForm } from "react-hook-form";
import MessageEditor from "ui/components/MessageEditor";
import { useRef, useCallback } from "react";
import CardDefault from "ui/components/Cards/CardDefault";
import ButtonAnexarArquivos from "ui/components/Button/ButtonAnexarArquivos";
import { Switch } from "@chakra-ui/switch";
import { Image } from "@chakra-ui/react";
import OutlineButton from "ui/components/Button/OutlineButton";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import useSalvarPostagem from "core/features/mural/hooks/useSalvarPostagem";
import history from "infra/helpers/history";
import { showErrorAxios } from "infra/helpers/alerta";
import usePost from "core/features/mural/hooks/usePost";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import moment from "moment";
import { useLoading } from "ui/components/GlobalLoading";

function DetalhePostagem() {
  const [localLoading, setLocalLoading] = useState(false);
  const { id } = useParams() as { id?: string };

  const { control, setValue, handleSubmit, watch, reset } =
    useForm<CriarPostagemForm>({
      reValidateMode: "onChange",
      mode: "onChange",
      defaultValues: {
        ativo: true,
      },
    });

  const form = watch();

  const inputRef = useRef<HTMLTextAreaElement | null>(null);
  const imagem = watch("imagem");
  const imageUrl =
    imagem && typeof imagem != "string"
      ? URL.createObjectURL(imagem)
      : imagem
      ? imagem
      : undefined;

  const { data, isLoading, isFetching } = usePost(id);
  useEffect(() => {
    if (data) {
      setLocalLoading(true);
      reset({
        ...data,
        dataPublicacao: moment(data.dataPublicacao).format("YYYY-MM-DD"),
      });
    }
  }, [data, reset]);

  useEffect(() => {
    if (localLoading && form.dataPublicacao) {
      setLocalLoading(false);
    }
  }, [localLoading, form]);

  const { mutate: handleCriar, isLoading: isLoadingSave } =
    useSalvarPostagem(id);

  const handleFormSubmit = async (data: CriarPostagemForm) => {
    handleCriar(data, {
      onSuccess: () => {
        history.push("/administracao/mural");
      },
      onError: (err) => {
        showErrorAxios(err);
      },
    });
  };

  useLoading(isLoading);

  const onChange = useCallback(
    (html: string, plainText?: string) => {
      setValue("descricao", html);
      setValue("descricaoPlain", plainText);
    },
    [setValue]
  );

  return (
    <>
      <PageHeader title="Mural" mb="6" />
      <CardDefault>
        <Flex mb="6" gap={6}>
          <Field name="titulo" control={control} label="Titulo" />
          <Field name="link" control={control} label="Link" />
        </Flex>

        <Flex flexDir="column">
          <p style={{ fontWeight: "bold", marginBottom: "10px" }}>Descrição</p>
          <Field
            name="descricao"
            control={control}
            render={({ field }) => {
              field.ref(inputRef.current);
              return (
                <MessageEditor
                  value={field.value}
                  loading={isLoading || isFetching || localLoading}
                  onChange={onChange}
                  heightType={2}
                  autoFocus
                />
              );
            }}
          />
        </Flex>
        <Flex mt="6" mb="6" maxW="120px">
          <Field
            name="imagem"
            rules={{
              required: true,
            }}
            control={control}
            render={({ field }) => {
              return (
                <ButtonAnexarArquivos
                  multiple={false}
                  buttonText="Imagem"
                  accept="image/*"
                  variant="outline"
                  onAnexar={(files) => {
                    field.onChange(files!?.[0]);
                  }}
                />
              );
            }}
          />
        </Flex>
        <Flex gap={20}>
          <Image htmlWidth={200} h="120px" objectFit="cover" src={imageUrl} />
          <Field
            label="Data de publicação"
            control={control}
            rules={{ required: true }}
            inputProps={{ type: "date" }}
            name="dataPublicacao"
          />
          <Field
            name="ativo"
            label="Ativo"
            control={control}
            render={({ field }) => {
              return (
                <Switch
                  isChecked={field.value}
                  onChange={() => {
                    field.onChange(!field.value);
                  }}
                  size="lg"
                />
              );
            }}
          />
        </Flex>
        <Flex justifyContent="flex-end">
          <OutlineButton
            mr="2"
            onClick={() => {
              history.push("/administracao/mural");
            }}
          >
            Cancelar
          </OutlineButton>
          <PrimaryButton
            onClick={handleSubmit(handleFormSubmit)}
            disabled={isLoadingSave}
            isLoading={isLoadingSave}
          >
            Enviar
          </PrimaryButton>
        </Flex>
      </CardDefault>
    </>
  );
}

export default DetalhePostagem;
